import { useEffect, useRef, useState } from 'react';

import { useCatalogProductIdParams } from '@domains/pdp-common';

import { overseas_direct_purchase_size_tab, tab_list, TabName } from '../../../constant/size-table';
import { useSizeInfo } from '../../../queries/useSizeInfoQuery';

export const useLegacySizeInfoService = () => {
  const param = useCatalogProductIdParams();
  const language = 'ko';
  const { data } = useSizeInfo(param);

  const only_once = useRef<boolean>(false);
  const [active_tab, setActiveTab] = useState<TabName>(TabName.woman);

  useEffect(() => {
    if (only_once.current) {
      return;
    }
    if (data?.managed_category_list?.length) {
      only_once.current = true;
      data.managed_category_list.forEach((category) => {
        if (category.key === 'luxuries_posty_women_wear') {
          setActiveTab(TabName.woman);
        } else if (category.key === 'luxuries_posty_men_wear') {
          setActiveTab(TabName.man);
        } else if (category.key === 'luxuries_posty_women_shoes' || category.key === 'luxuries_posty_men_shoes') {
          setActiveTab(TabName.shoes);
        }
      });
    }
  }, [data?.managed_category_list]);

  const hideOverseas = !data?.trait_list?.find((o) => o.type === 'OVERSEAS_DIRECT_PURCHASE');
  const hasActualSizeInfo = Boolean(data?.item_list.length);
  const hasAiCropSizeInfo = Boolean(data?.item_list?.find((item) => item.is_ai_image_zoom_button_visible));
  const isKorean = language === 'ko';

  const table_list = overseas_direct_purchase_size_tab[active_tab];

  const onClickTab = (tab: TabName) => {
    setActiveTab(tab);
  };

  return {
    hideActualSize: !hasActualSizeInfo || hasAiCropSizeInfo,
    hideAiCropSize: !hasAiCropSizeInfo,
    hideSizeGuide: isKorean,
    hideOverseas,
    tab_list,
    table_list,
    active_tab,
    onClickTab,
  };
};
